import { useEffect, useRef, useState } from "react";

export default function About() {
  const ref = useRef<HTMLDivElement>(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => { if (entry.isIntersecting) setVisible(true); },
      { threshold: 0.2 }
    );
    if (ref.current) observer.observe(ref.current);
    return () => observer.disconnect();
  }, []);

  return (
    <section id="about" className="py-28 md:py-36 bg-[#faf8f4]" ref={ref}>
      <div className="max-w-7xl mx-auto px-6 md:px-16">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          {/* Left: Text */}
          <div
            className={`transition-all duration-1000 ${
              visible ? "opacity-100 translate-x-0" : "opacity-0 -translate-x-8"
            }`}
          >
            {/* Section Label */}
            <div className="flex items-center gap-3 mb-6">
              <span className="w-10 h-px bg-[#8b6f47]"></span>
              <span
                className="text-[#8b6f47] text-[1rem] tracking-[0.3em] font-medium"
                style={{ fontFamily: "'Noto Serif TC', serif" }}
              >
                ABOUT US
              </span>
            </div>

            <h2
              className="text-[#2d2520] font-bold mb-8 leading-[1.4]"
              style={{
                fontSize: "clamp(1.5rem, 3vw, 2.125rem)",
                fontFamily: "'Noto Serif TC', serif",
              }}
            >
              關於瓏靖手作能量
            </h2>

            <div
              className="text-[#5a4e45] leading-[1.75] space-y-5"
              style={{
                fontSize: "1.1875rem",
                fontFamily: "'Noto Serif TC', serif",
              }}
            >
              <p>
                瓏靖手作能量致力於傳遞東方文化中關於守護、祝福與能量平衡的理念。我們相信天地萬物皆蘊含能量與頻率，透過精選的西藏天珠、天然礦石水晶、翡翠玉石與唐卡佛牌，將這份古老的智慧與祝福帶入現代生活。
              </p>
              <p>
                每一件飾品都是文化、自然與手作工藝的結合，承載著千年傳承的能量與美感。我們以精品的標準嚴選每一件作品，讓您在日常中感受到東方文化的溫潤與守護。
              </p>
              <p>
                願每一位來到瓏靖的朋友，都能找到屬於自己的守護與力量。
              </p>
            </div>

            {/* Values */}
            <div className="grid grid-cols-2 gap-4 mt-10">
              {[
                { icon: "ri-shield-star-line", label: "守護祝福" },
                { icon: "ri-leaf-line", label: "天然材質" },
                { icon: "ri-hand-heart-line", label: "手作溫度" },
                { icon: "ri-ancient-gate-line", label: "文化傳承" },
              ].map((item) => (
                <div key={item.label} className="flex items-center gap-3">
                  <div className="w-9 h-9 flex items-center justify-center rounded-full bg-[#f0e8dc]">
                    <i className={`${item.icon} text-[#8b6f47] text-lg`}></i>
                  </div>
                  <span
                    className="text-[#5a4e45] text-[1rem] font-medium"
                    style={{ fontFamily: "'Noto Serif TC', serif" }}
                  >
                    {item.label}
                  </span>
                </div>
              ))}
            </div>
          </div>

          {/* Right: Image */}
          <div
            className={`transition-all duration-1000 delay-200 ${
              visible ? "opacity-100 translate-x-0" : "opacity-0 translate-x-8"
            }`}
          >
            <div className="relative">
              {/* Main Image */}
              <div className="w-full h-[520px] rounded-2xl overflow-hidden">
                <img
                  src="https://readdy.ai/api/search-image?query=elegant%20oriental%20energy%20jewelry%20collection%20display%20Tibetan%20dzi%20beads%20natural%20crystal%20jade%20bracelet%20arranged%20on%20white%20marble%20surface%20with%20dried%20flowers%20warm%20golden%20light%20luxury%20minimalist%20photography%20soft%20bokeh%20background%20serene%20atmosphere&width=700&height=900&seq=about001&orientation=portrait"
                  alt="瓏靖手作能量 品牌形象"
                  className="w-full h-full object-cover object-top"
                />
              </div>
              {/* Decorative Card */}
              <div className="absolute -bottom-6 -left-6 bg-white rounded-xl p-5 shadow-sm border border-[#e8e0d5]">
                <p
                  className="text-[#8b6f47] text-[1rem] font-medium mb-1"
                  style={{ fontFamily: "'Noto Serif TC', serif" }}
                >
                  嚴選品質
                </p>
                <p
                  className="text-[#2d2520] text-[1.5rem] font-bold"
                  style={{ fontFamily: "'Noto Serif TC', serif" }}
                >
                  每一件都是緣分
                </p>
              </div>
              {/* Gold Accent */}
              <div className="absolute -top-4 -right-4 w-24 h-24 rounded-full bg-[#c9a96e]/10 border border-[#c9a96e]/30"></div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
